'use client';

export namespace NotificationDispatcher {
    export type NotificationData = {
        type: 'SUCCESS' | 'ERROR' | 'WARNING' | 'ACTION';
        title: React.ReactNode;
        message?: React.ReactNode;
    };

    export type Notification = {
        duration: number;
        createdAt: number;
        data: NotificationData;
    };
}

export class NotificationDispatcher extends EventTarget {
    static DEFAULT_DURATION = 5000;

    notifications: NotificationDispatcher.Notification[] = [];

    constructor() {
        super();
    }

    removeNotification(notification: NotificationDispatcher.Notification) {
        const index = this.notifications.indexOf(notification);
        if (index !== -1) this.notifications.splice(index, 1);
        this.dispatchEvent(new CustomEvent('changed'));
        this.dispatchEvent(new CustomEvent('removed', { detail: notification }));
    }

    dispatchNotification(notification: NotificationDispatcher.Notification) {
        this.notifications.push(notification);
        setTimeout(() => {
            this.removeNotification(notification);
        }, notification.duration);
        this.dispatchEvent(new CustomEvent('changed'));
        this.dispatchEvent(new CustomEvent('added', { detail: notification }));
    }

    dispatch(
        data: NotificationDispatcher.NotificationData,
        createdAt: number = Date.now(),
        duration: number = NotificationDispatcher.DEFAULT_DURATION,
    ) {
        this.dispatchNotification({
            data,
            createdAt,
            duration,
        });
    }

    subscribe(listener: (notification: typeof this.notifications) => void) {
        const wrappedListener = () => listener([...this.notifications]);

        this.addEventListener('changed', wrappedListener);
        return () => {
            this.removeEventListener('changed', wrappedListener);
        };
    }
}
